import { render, staticRenderFns } from "./AssemblyDetailsModal.vue?vue&type=template&id=4e06c1da&scoped=true"
import script from "./AssemblyDetailsModal.vue?vue&type=script&lang=js"
export * from "./AssemblyDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./AssemblyDetailsModal.vue?vue&type=style&index=0&id=4e06c1da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e06c1da",
  null
  
)

export default component.exports